import React from "react";
import { News } from "./News";

export const Contest = () => {

  return (
    <div className="mb-20">
      <div className="flex items-center staticBanner bg-[#cbbef0] relative">
        <div className="staticBannerContent">
          <img
            src="/images/infoBanner.png"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] translate-x-[59%] max-h-full overflow-auto">
            <h2 className="font-black text-primaryDark">活動競賽</h2>
            {/* <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              參加高雄市數位研習活動，掌握最新教學科技，提升教學智慧，讓學生學習效果更卓越！這裡專門提供教師的研習資訊，助您持續進步。
            </p> */}
          </div>
        </div>
      </div>

      <div className='content text-Headline px-4 mx-auto'>
        <div className='text-lg lg:text-3xl w-fit border-b-4 border-primary font-medium mt-6 mb-4 lg:my-12 p-1 lg:p-3 mx-auto'>活動競賽</div>
        {/* <div className="flex justify-center mb-6 lg:mb-8">

        </div> */}
        <News tag='活動競賽' />

      </div>

      <div className='p-7 lg:p-16'></div>
    </div>
  );
};
